import React, { useEffect, useState } from "react";
import { Box, Typography, Button, IconButton, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import InputField from "../../../../Components/Masters/InputField";
import SelectField from "../../../../Components/Masters/SelectField";
import contries from "../../Roles and Permissions/Country.json";
import PhoneField from "../../../../Components/Masters/PhoneField";
import EmailField from "../../../../Components/Masters/EmailField";
import EditDialog from "../../../../Components/Common/EditDialog";
import { validateNumber } from "../../../../utils/validateFields";
import { post, put } from "../../../../utils/api";
import PhoneFieldInput from "../../../../Components/Masters/PhoneFieldInput";
import { europeanCountries } from "../../../../utils/countriesArray";

function AddPurchasedGoods({
  inputData,
  fetchData,
  id,
  element,
  data,
  setAddData,
  addData,
  setsnackOpen,
  addUrl,
  updateUrl,
}) {
  const [errors, setErrors] = useState({});
  const initialState = {
    vendorLegalName: element?.vendorLegalName || "",
    country: element?.country || "",
    goodsAndServicesName: element?.goodsAndServicesName || "",
    gstNumber: element?.gstNumber || "",
    address: element?.address || "",
    personInChargeName: element?.personInChargeName || "",
    contactNumber: {
      countryCode: element?.contactNumber?.countryCode || "",
      mobileNo: element?.contactNumber?.mobileNo || "",
    },
    email: element?.email || "",
  };
  const [formData, setFormData] = useState(initialState);
  const [regex, setRegex] = useState({});
  const [verifybtn, setverifybtn] = useState({ email: false, phone: false });
  const [verify, setVerify] = useState({
    phone: false,
    email: false,
    emailMsg: "",
    phoneMsg: "",
  });
  const [TaskAltIcons, setTaskAltIcons] = useState({
    email: false,
    phone: false,
  });
  // Time state

  const [editDialog, setEditDialog] = useState(false);
  const [formData2, setFormData2] = useState(initialState);

  useEffect(() => {
    setFormData(initialState);
    setFormData2(initialState);
    if (id && element) {
      setTaskAltIcons({ ...TaskAltIcons, phone: true, email: true });
    } else if (!id && !element) {
      setTaskAltIcons({ ...TaskAltIcons, phone: false, email: false });
    }
  }, [element, id]); // Ensure this runs when data changes

  const requiredLength = () => {
    // Assuming selectedCountry is available and has the regex string
    const regexString = regex?.key1regex || "^[A-Za-z0-9]{15}$"; // fallback to 15-char alphanumeric
    const match = regexString.match(/\{(\d+)\}/);

    if (match) {
      return parseInt(match[1], 10); // e.g., 15
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value, "value");
    let length = null;
    if (name === "contactNumber") {
      setFormData((prevState) => ({
        ...prevState,
        contactNumber: {
          ...prevState.contactNumber, // this ensures countryCode stays
          countryCode: formData?.contactNumber?.countryCode,
          mobileNo: value,
        },
      }));

      const mobile = data?.filter(
        (el) => el?.contactNumber?.mobileNo === value
      );

      if (
        mobile?.length > 0 &&
        (element ? element?._id !== mobile[0]?._id : true)
      )
        setErrors({ ...errors, [name]: "Contact Number Already exists." });
      return;
    }
    // Assuming selectedCountry is available and has the regex string
    if (name === "gstNumber") {
      length = requiredLength();

      if (length && value?.length > length) {
        return; // skip further updates if too long
      }
    }

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    setErrors((prevState) => ({
      ...prevState,
      [name]: "",
    }));

    // Vendor legal name duplication check
    if (name === "vendorLegalName") {
      const regex = new RegExp(`^${value}$`, "i");
      const vendor = data.filter((el) => regex.test(el.vendorLegalName));
      if (
        vendor.length > 0 &&
        (element ? element._id !== vendor[0]._id : true)
      ) {
        setErrors({ ...errors, [name]: "Vendor Legal Name already exists." });
      }
      return;
    }

    // GST number duplication and format validation
    if (name === "gstNumber") {
      const gst = data.filter((el) =>
        new RegExp(`^${value}$`, "i").test(el.gstNumber)
      );
      if (gst.length > 0 && (element ? element._id !== gst[0]._id : true)) {
        setErrors({ ...errors, [name]: "GST Number Already exists." });
        return;
      }

      // ✅ Validate format using key1regex from selectedCountry
      const regex1 = new RegExp(regex?.key1regex);
      if (value?.length === length && !regex1.test(value)) {
        setErrors({
          ...errors,
          [name]: `Invalid Format`,
        });
      }
    }

    if (name === "email") {
      const email = data?.filter((el) => el?.email === value);
      if (
        email?.length > 0 &&
        (element ? element?._id !== email[0]?._id : true)
      )
        setErrors({ ...errors, [name]: "Email ID Already exists." });
      return;
    }
  };

  const handleCountryChange = (event) => {
    const selectedCountryCode = event.target.value;
    console.log(selectedCountryCode, event.target.name);
    setErrors({ ...errors, country: "", gstNumber: "" });
    // setVerify({ ...verify, phone: false, phoneMsg: "" });
    const selectedCountry = contries.countries.find(
      (country) => country.name === selectedCountryCode
    );

    if (selectedCountry) {
      // setErrors({ ...errors, contactNumber: "" });
      setTaskAltIcons({ ...TaskAltIcons, phone: false });
      setFormData((prevData) => ({
        ...prevData,
        country: selectedCountry.name,
        gstNumber: "",
        contactNumber: {
          ...prevData.contactNumber,
          countryCode: selectedCountry.dial_code,
          mobileNo: "",
        },
      }));
      console.log(
        europeanCountries?.find((i) => i?.countryName === selectedCountry.name),
        "regex1"
      );
      setRegex({
        ...europeanCountries?.find(
          (i) => i?.countryName === selectedCountry.name
        ),
      });
      if (errors.contactNumber === "Please Select Country.")
        setErrors({ ...errors, contactNumber: "" });
    } else {
      console.error("Country not found in data");
    }
  };

  const handleExitAgree = () => {
    setEditDialog(false);
    setAddData(false);
    setErrors({});
    setverifybtn({ phone: false, email: false });
    setVerify({ phone: false, email: false, emailMsg: "", phoneMsg: "" });
    setFormData(initialState);
    setFormData2(initialState);
    // if (data && id) setTaskAltIcons({ phone: true, email: true });
    // if (!data && !id) {
    setTaskAltIcons({ phone: false, email: false });
    // }
  };

  const handleClose = () => {
    const isFormDataUnchanged = Object.keys(formData).every(
      (key) => formData[key] === formData2[key]
    );

    if (isFormDataUnchanged) {
      handleExitAgree();
    } else {
      setEditDialog(true);
    }
  };

  const validateForm = () => {
    const newErrors = { ...errors };
    // setVerify({...verify,emailMsg:"",phoneMsg:""})

    inputData.forEach((input) => {
      const value = formData[input.fieldName];
      const reg = new RegExp(`^${value}$`, "i"); // 'i' flag makes it case-insensitive

      if (input.fieldName === "contactNumber") {
        const mobileNo = formData?.contactNumber.mobileNo;
        // const mobile = data?.filter((el) =>
        //   el?.contactNumber?.mobileNo===mobileNo
        // );
        if (!mobileNo)
          newErrors[input.fieldName] = `${input.title} is required`;
        else if (formData.contactNumber.countryCode === "")
          newErrors[input.fieldName] = "Please Select Country";
        else if (!validateNumber(mobileNo) || mobileNo?.length < 7)
          newErrors[input.fieldName] = "Please enter valid Contact Number";
        // else if (
        //   mobile?.length > 0 && (element ? element?._id !== mobile[0]?._id : true)
        // )
        //   newErrors[input.fieldName] = `${input.title} Already exists.`;
      }
      if (input.fieldName === "email") {
        // const emailId = data.filter((el) => el?.email===formData?.email);

        if (formData?.email === "")
          newErrors[input.fieldName] = `${input.title} is required`;
        // else if (
        //   emailId?.length > 0 && (element ? element._id !== emailId[0]._id : true)
        // )
        //   newErrors[input.fieldName] = `${input.title} Already exists.`;
      } else if (input.fieldName === "gstNumber") {
        // const gst = data.filter((el) => reg.test(el.gstNumber));
        // // Check if the GST Number already exists and the IDs don't match (or if no GST record exists, skip the validation
        // if (gst.length > 0 && (element ? element._id !== gst[0]._id : true)) {
        //   newErrors[input.fieldName] = `${
        //     regex?.key1 || input.title
        //   } Already exists.`;
        // }
        const regex1 = new RegExp(regex?.key1regex);
        if (value === "")
          newErrors[input.fieldName] = `${
            regex?.key1 || input.title
          } is Required.`;
        else if (value?.length !== requiredLength() || !regex1.test(value))
          newErrors[input.fieldName] = `Invalid Format`;
      } else if (!value || value === "") {
        newErrors[input.fieldName] = `${input.title} is required`;
      }
    });
    setErrors({ ...errors, ...newErrors });
    return Object.keys(errors).length > 0 ? errors : false;
  };

  const Save = async () => {
    console.log("first123");
    if (!validateForm()) return;
    console.log("first1234");
    let method = id ? put : post;
    let url = id ? `${updateUrl}/${id}` : addUrl;

    await method(url, formData)
      .then((res) => {
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        fetchData();
        handleExitAgree();
      })
      .catch((err) => {
        console.log(err.response.data);
        if (err.response && err.response.data && err.response.data.errors) {
          const errorMessages = err.response.data.errors
            .map((error) => error.msg)
            .join(", ");
          setsnackOpen({
            open: true,
            message: errorMessages,
            severity: "error",
          });
        }
      });

    setVerify({});
    setverifybtn({});
  };

  const renderInputField = (el) => {
    if (el.fieldName === "contactNumber")
      return (
        <Box>
          <PhoneFieldInput
            value={formData?.contactNumber?.mobileNo || ""} // Use optional chaining
            errors={errors[el.fieldName]}
            fieldName={el.fieldName}
            placeholder={el.placeholder}
            handleChange={handleChange}
            title={el.title}
            showIcon={TaskAltIcons.phone === true}
            {...{
              setTaskAltIcons,
              TaskAltIcons,
              setErrors,
              setFormData,
              element,
              formData,
              setVerify,
              verify,
              setverifybtn,
              verifybtn,
            }}
            countryCode={formData?.contactNumber?.countryCode || ""} // Use optional chaining
          />
        </Box>
      );

    if (el.fieldName === "email")
      return (
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 2 }}>
            {el.title}
          </Typography>
          <TextField
            placeholder={el.placeholder}
            size="small"
            fullWidth
            name={el.fieldName}
            value={formData?.email || ""}
            onChange={handleChange}
            error={Boolean(errors[el.fieldName])}
            // helperText={errors[el.fieldName] || ""}
          />
          <Typography variant="body2" color="#D34040">
            {errors[el.fieldName]}
          </Typography>
        </Box>
      );

    if (el.type === "select")
      return (
        <SelectField
          title={el.title}
          name={el.fieldName}
          value={formData[el.fieldName]}
          handleChange={handleCountryChange}
          options={contries.countries}
          errors={errors[el.fieldName]}
        />
      );

    return (
      <InputField
        title={
          el?.fieldName === "gstNumber"
            ? europeanCountries?.find(
                (i) => i?.countryName === formData?.country
              )?.key1 || el?.title
            : el.title
        }
        handleChange={handleChange}
        placeholder={
          el?.fieldName === "gstNumber"
            ? `Enter ${
                europeanCountries?.find(
                  (i) => i?.countryName === formData?.country
                )?.key1 || el?.title
              }`
            : el.placeholder
        }
        value={formData[el.fieldName] || ""}
        errors={errors[el.fieldName]}
        fieldName={el.fieldName}
      />
    );
  };

  const list = () => (
    <Box display="flex" gap={3} sx={{ width: "25.6rem" }}>
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}

      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          width: "90%",
          p: 3,
          backgroundColor: "#fff",
          height: "100vh",
          overflowY: "scroll",
        }}
      >
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {id
            ? "Edit Purchased Goods and Services Vendor"
            : "Add Purchased Goods and Services Vendor"}
        </Typography>
        {inputData.map((el) => (
          <div key={el.fieldName}>{renderInputField(el)}</div>
        ))}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        height: "100vh",
        minHeight: "100vh",
        overflowY: "auto",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100vh",
          minHeight: "100vh",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleClose}
    >
      {list()}
    </Drawer>
  );
}

export default AddPurchasedGoods;
